module.exports = __webpack_public_path__ + "static/audiobook-mobile-plp-e78c98442662aec795a6ad3719a85244.png";